module.exports = __webpack_public_path__ + "static/banner-7-4e3d0c17153346ff0c365890d58f789e.svg";